import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import * as DateFns from 'date-fns';

import Table, { RowType } from '../../../Shared/CustomTable';
import { fixDecimals, getTeamProps, saveDataEventsOnLocalStorage } from '../../../../helpers/helpers';
import Loader from '../../../Shared/Loader';
import { useRouter } from '../../../../helpers/customHooks';
import { useDataPlayersDispatch, useDataPlayersState, useFiltersState } from '../../../../store/hooks';
import { FILTER_GLOBAL_KEYS, FILTER_KEYS, LEAGUES, MESSAGES } from '../../../../config/constants';
import { PlayerRoutes } from '../../types';
import { OpponentData, ScoreData } from 'components/Games/types';

export default () => {

  const { match, location, specificScope } = useRouter<PlayerRoutes>();
  const { playerGames: games, dataPlayer } = useDataPlayersState(match.params.playerId);
  const {
    [FILTER_GLOBAL_KEYS.WEEKS]: weeks,
    [FILTER_KEYS.DATE_RANGE]: filterDateRangeData
  } = useFiltersState(specificScope, FILTER_GLOBAL_KEYS.WEEKS, FILTER_KEYS.DATE_RANGE);
  const { getPlayerMetrics: loadGames } = useDataPlayersDispatch();
  const league = (getTeamProps(dataPlayer?.meta.teamId)||{league: ''}).league;
  useEffect(() => {
    if (weeks && filterDateRangeData && filterDateRangeData.selectedDates && filterDateRangeData.selectedDates.length) {
      loadGames();
    }
  }, [weeks, filterDateRangeData]);
  useEffect(() => {
    saveDataEventsOnLocalStorage(games?.map(game => game.gameId));
  }, [games]);
  const headers = [
    //{class: 'oo-i', isCheckboxCell: true, isSelectable: true, width:'44px', minWidth: '44px', maxWidth:'44px'}, //isCheckboxCell: put in content a checkbox, isSelectable: select all or nothing
    { content: 'GAME', style: { width: '191px', paddingLeft: '20px' }, isOrderly: true },
    ...(league === LEAGUES.NFL) ? [{
      content: 'SCORE',
      style: { width: '115px' },
      isOrderly: true,
      leftSortIcon: '16px'
    }] : [{style:{width: '115px'}}],
    { content: 'DATE/TIME', style: { width: '150px' }, isOrderly: true },
    { content: 'MAX SPEED', style: { width: '87px' }, class: 'll-pp', isOrderly: true },
    { content: 'MAX SUST. SPEED', style: { width: '87px' }, class: 'll-pp', isOrderly: true },
    { content: 'TTL DIST.', style: { width: '75px' }, class: 'll-pp', isOrderly: true },
    { content: 'ACCEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true },
    { content: 'DECEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true },
    { content: '', style: { width: '472px' } }
  ];
  const rows: RowType[] = [];
  games && games.forEach((game, index) => {
    const isAway = !game.local;
    rows.push({
      columns: [
        //{class: 'oo-i', isCheckboxCell: game.completed, width:'44px', minWidth: '44px', maxWidth:'44px'},
        ...(league === LEAGUES.NFL) ? [{
          content: {
            opponentNick: game.opponentTeamNickname,
            opponentAbbr: game.opponentTeamAbbrName
          },
          print: (content: OpponentData) => {
            let component = <label className="l-c" style={{ cursor: 'pointer' }}>{isAway ? '@ ' : 'vs '}
              <img src={`/assets/images/logos/${content.opponentAbbr}.svg`} alt="" width="20px" />
              <b>{content.opponentAbbr + ' ' + content.opponentNick}</b>
            </label>;
            if (game.metrics) {
              component = <Link
                to={{
                  pathname: dataPlayer && dataPlayer.meta && dataPlayer.meta.playerId ? `/view/game/${game.gameId}/${game.metrics.teamId}/performance/expanded/modal/${dataPlayer.meta.playerId}`
                  : `/view/game/${game.gameId}/${game.metrics.teamId}/performance/expanded/page`,
                  state: {
                    toReturn: location.pathname,
                    toReturnSearch: location.search
                  }
                }}
              >
                <label className="l-c" style={{ cursor: 'pointer' }}>{isAway ? '@ ' : 'vs '}
                  <img src={`/assets/images/logos/${content.opponentAbbr}.svg`} alt="" width="20px" />
                  <b>{content.opponentAbbr + ' ' + content.opponentNick}</b>
                </label>
              </Link>;
            }
            return component;
          },
          order: (contentA: OpponentData, contentB: OpponentData) => contentA.opponentNick.localeCompare(contentB.opponentNick),
          style: { paddingLeft: '20px' }
        }] : [{
          // NCAA game format
          content: game.practiceName,
          style: { paddingLeft: '20px' },
          print: (content: string) => {
            if (game.metrics) {
              return (
                <Link
                  to={{
                    pathname: `/view/game/${game.gameId}/${game.metrics.homeTeamId}/performance/expanded/page`,
                    state: {
                      toReturn: location.pathname,
                      toReturnSearch: location.search,
                    }
                  }}
                >
                  <b>{content}</b>
                </Link>
              );
            } else {
              return <b>{content}</b>;
            }
          }
        }],
        ...(league === LEAGUES.NFL) ? [{
          content: {
            ownScore: game.teamScore,
            opponentScore: game.opponentTeamScore,
            win: game.teamScore > game.opponentTeamScore
          },
          style: { width: '115px', minWidth: '115px', maxWidth: '115px' },
          print: (content: ScoreData) => {
            let component = (
              <label className="l-c">
                {content.win ? <span className="s-g">W</span> : <span className="s-r">L</span>}
                <b>{' ' + content.ownScore}</b>-{content.opponentScore}
              </label>
            );
            if (!game.completed) {
              component = (
                <label className="l-c" style={{ color: '#778893' }}>
                  Game not completed
                </label>
              );
            }
            return component;
          },
          order: (contentA: ScoreData, contentB: ScoreData) => +contentB.ownScore - +contentA.ownScore
        }] : [{style:{width: '115px'}}],
        {
          content: { startDate: game.startDate },
          print: (content) => <label
            className="l-c"
          >{DateFns.format(new Date(content.startDate), 'MM/dd/yyyy, hh:mmaaaaa\'m\'')}</label>,
          order: (contentA, contentB) => contentA.startDate - contentB.startDate
        },
        {
          class: 'll-pp',
          content: {
            printAveSpeedMPH: league === LEAGUES.NFL? game.metrics && game.completed ? fixDecimals(game.metrics.maxSpeed, 1) : '-':
            game.metrics? fixDecimals(game.metrics.maxSpeed, 1) : '-',
            aveSpeedMPH: league === LEAGUES.NFL? game.metrics && game.completed ? fixDecimals(game.metrics.maxSpeed, 1) : -100000 :
            game.metrics ? fixDecimals(game.metrics.maxSpeed, 1) : -100000
          },
          print: (content) => {
            return <label className="l-c">{content.printAveSpeedMPH}</label>;
          },
          order: (contentA, contentB) => contentA.aveSpeedMPH - contentB.aveSpeedMPH
        },
        {
          class: 'll-pp',
          content: {
            aveMaxSustainedSpeed: league === LEAGUES.NFL? game.metrics && game.completed ? game.metrics.maxSustainedSpeed : -100000 :
            game.metrics ? game.metrics.maxSustainedSpeed : -100000,
            printAveMaxSustainedSpeed: league === LEAGUES.NFL? game.metrics && game.completed ? fixDecimals(game.metrics.maxSustainedSpeed, 1) : '-' :
            game.metrics ? fixDecimals(game.metrics.maxSustainedSpeed, 1) : '-'
          },
          print: (content) => <label className="l-c">{content.printAveMaxSustainedSpeed}</label>,
          order: (contentA, contentB) => contentA.aveMaxSustainedSpeed - contentB.aveMaxSustainedSpeed
        },
        {
          class: 'll-pp',
          content: {
            aveDistYards: league === LEAGUES.NFL? game.metrics && game.completed? game.metrics.totalDis : -100000 : 
            game.metrics ? game.metrics.totalDis : -100000,
            printAveDistYards: league === LEAGUES.NFL? game.metrics && game.completed ? fixDecimals(game.metrics.totalDis, 0) : '-' :
            game.metrics ? fixDecimals(game.metrics.totalDis, 0) : '-'
          },
          print: (content) => <label className="l-c">{content.printAveDistYards}</label>,// style: {width: '7%'},
          order: (contentA, contentB) => contentA.aveDistYards - contentB.aveDistYards
        },
        {
          class: 'll-pp',
          content: {
            aveAccel: league === LEAGUES.NFL? game.metrics && game.completed ? (game.metrics.accelSlow + game.metrics.accelMed + game.metrics.accelFast) : -100000 :
            game.metrics ? (game.metrics.accelSlow + game.metrics.accelMed + game.metrics.accelFast) : -100000,
            printAveAccel: league === LEAGUES.NFL? game.metrics && game.completed ? fixDecimals(game.metrics.accelSlow + game.metrics.accelMed + game.metrics.accelFast, 0) : '-' :
            game.metrics ? fixDecimals(game.metrics.accelSlow + game.metrics.accelMed + game.metrics.accelFast, 0) : '-'
          },
          print: (content) => <label className="l-c">{content.printAveAccel}</label>,
          order: (contentA, contentB) => contentA.aveAccel - contentB.aveAccel
        },
        {
          class: 'll-pp',
          content: {
            aveDecel: league === LEAGUES.NFL? game.metrics && game.completed ? (game.metrics.deccelSlow + game.metrics.deccelMed + game.metrics.deccelFast) : -100000 :
            game.metrics ? (game.metrics.deccelSlow + game.metrics.deccelMed + game.metrics.deccelFast) : -100000,
            printAveDecel: league === LEAGUES.NFL? game.metrics && game.completed ? fixDecimals(game.metrics.deccelSlow + game.metrics.deccelMed + game.metrics.deccelFast, 0) : '-' :
            game.metrics ? fixDecimals(game.metrics.deccelSlow + game.metrics.deccelMed + game.metrics.deccelFast, 0) : '-'
          },
          print: (content) => <label className="l-c">{content.printAveDecel}</label>,
          order: (contentA, contentB) => contentA.aveDecel - contentB.aveDecel
        },
        {
          class: 'oo-ut',
          content: league === LEAGUES.NFL? game.metrics && game.completed ?
          (
            <>
              <Link
                to={{
                  pathname: dataPlayer && dataPlayer.meta && dataPlayer.meta.playerId ? `/view/game/${game.gameId}/${game.metrics.teamId}/performance/expanded/modal/${dataPlayer.meta.playerId}`
                  : `/view/game/${game.gameId}/${game.metrics.teamId}/performance/expanded/page`,
                  state: {
                    toReturn: location.pathname,
                    toReturnSearch: location.search
                  }
                }}
              >
                <Button className="btn-blue"> View Full Game Data</Button>
              </Link>
            </>) : <></>
          : game.metrics ? (
            <>
              <Link
                to={{
                  pathname: dataPlayer && dataPlayer.meta && dataPlayer.meta.playerId ? `/view/game/${game.gameId}/${game.metrics.teamId}/performance/expanded/modal/${dataPlayer.meta.playerId}`
                  : `/view/game/${game.gameId}/${game.metrics.teamId}/performance/expanded/page`,
                  state: {
                    toReturn: location.pathname,
                    toReturnSearch: location.search
                  }
                }}
              >
                <Button className="btn-blue"> View Full Game Data</Button>
              </Link>
            </>) : <></>
        }
      ],
      id:` ${game.gameId}-${index}`
    });
  });
  return (
  <>
  <Loader forceLoader={!weeks}>  
  {games && games.length === 0 ? 
  <Loader forceMessage={ MESSAGES.EMPTY }/>
  : 
  <Table
      classTable='default-table-width'
      headers={headers}
      default={{ orderColumn: 3}}
      rows={rows}
      isSelectedStyle
    />
  }
  </Loader>;
  </>
  );
};
